<template>
  <div style="height: 100%">
    <div class="nothing" v-if="list1.length === 0 && tabidx == 0">
      <img src="../../../assets/img/not_found_data.png" alt="">
    </div>
    <div class="nothing" v-if="list2.length === 0 && tabidx == 1">
      <img src="../../../assets/img/not_found_data.png" alt="">
    </div>
    <!--    计费概况-->
    <div v-if="tabidx == 0">
      <div v-for="(item, index) in list1" :key="index" v-show="item.roomList.length > 0">
        <div class="title">{{ item.floorName }}</div>
        <div class="card">
          <div class="card-item" :style="`height: ${val.chargingModel === '先用后付' && '155rem'}`"
               v-for="val in item.roomList"
               :key="val.roomId">
            <el-tag v-show="val.roomStatus === '未开户'" type="primary" class="card-item-price" effect="dark" size="mini">
              {{ val.roomStatus }}
            </el-tag>
            <el-tag v-show="val.roomStatus === '电表离线'" color="#b8b9bb" class="card-item-price" effect="dark"
                    size="mini">
              {{ val.roomStatus }}
            </el-tag>
            <el-tag v-show="val.roomStatus === '余额不足'" color="#ff9d4d" class="card-item-price" effect="dark"
                    size="mini">
              {{ val.roomStatus }}
            </el-tag>
            <el-tag v-show="val.roomStatus === '欠费'" color="#E8684A" class="card-item-price" effect="dark" size="mini">
              {{ val.roomStatus }}
            </el-tag>
            <el-tag v-show="val.roomStatus === '欠费断电'" color="#fd4238" class="card-item-price" effect="dark"
                    size="mini">
              {{ val.roomStatus }}
            </el-tag>
            <div class="card-item-box1" style="width: 75%">房间号：{{ val.roomName || '--' }}</div>
            <div class="card-item-box1">{{ val.enterpriseName || '--' }}</div>
            <div class="card-item-box1">付费模式：{{ val.chargingModel || '--' }}</div>
            <div v-show="val.chargingModel !== '先用后付'" class="card-item-box1">透支断电：￥{{ val.overdraft }}</div>
            <div class="card-item-box1">合闸状态： <span
                :style="`color: ${val.brakeType === 1 && '#acacac' }`">{{
                val.brakeType === 0 ? '合闸' : (val.brakeType === 1 ? '未合闸' : '--')
              }}</span>
            </div>
            <div v-show="val.chargingModel !== '先用后付'" class="card-item-box1">剩余金额：
              <span
                  :style="`color: ${val.roomStatus === '欠费' ? '#E8684A': (val.roomStatus === '欠费断电' ? '#FF0000' : (val.roomStatus === '余额不足' ? '#409eff' : '#333'))}`">
                  ￥{{ (!!val.totalbalance || val.totalbalance == 0) ? val.totalbalance : '--' }}
              </span>
            </div>
            <div class="card-item-manage" style="padding: 50rem 0 0 50rem" @click="handleDialog('manage', '', '', val)">
              <el-tag
                  style="cursor:pointer; min-width: 48rem; text-align: center; font-size: 14rem"
                  v-show="val.roomStatus !== '未开户'"
                  effect="dark"
                  size="small"
                  color="#0D94FF"
              >
                管理
              </el-tag>
            </div>
          </div>
        </div>
        <el-divider/>
      </div>
    </div>
    <!--    账单管理-->
    <div class="card" v-if="tabidx == 1 && isRefresh">
      <div :class="item.enable == 1 ? 'card-item' : 'card-item card-item1'" v-show="list2.length !== 0"
           :style="`width: calc(33.33% - 16rem);`"
           v-for="item in list2" :key="item.id">
        <!--        多选框-->
        <div class="card-item-checked">
          <el-checkbox class="checkbox" v-model="item.checked"/>
        </div>
        <div class="card-item-box">{{ item.enterpriseName }}</div>
        <div class="card-item-box">房间号：{{ item.roomNames && item.roomNames.split(' ').join('、') }}</div>
        <div class="card-item-box">
          付费模式：{{ item.chargingModel }}
        </div>
        <div class="card-item-box">电费单价：<span class="card-item-box-span">￥{{ Number(item.price).toFixed(2) }}</span>
        </div>
        <div class="card-item-box"> 消耗电量：<span class="card-item-box-span">{{ Number(item.dosage).toFixed(2) }}kWh</span>
        </div>
        <div class="card-item-box">费用小计：<span class="card-item-box-span">￥{{ Number(item.cost).toFixed(2) }}</span>
        </div>
        <p class="card-item-manage">
          <el-tag
              v-if="item.enable == 1"
              style="
                margin-bottom: 8rem;
                width: 104rem;
                height: 36rem;
                line-height: 36rem;
                text-align: center;
                font-size: 18rem;
                cursor: pointer;
              "
              color="#e8684a" size="medium"
              @click="handleDialog('close','', '', item)">
            <span style="color: #fff">销户退租</span>
          </el-tag>
          <br/>
          <el-tag effect="dark" style="
                width: 104rem;
                height: 36rem;
                line-height: 36rem;
                text-align: center;
                font-size: 18rem;
                cursor: pointer;
              " size="medium" @click="preview(item)">
            预览账单
          </el-tag>
        </p>
      </div>
      <div class="allselect">
        <div class="btn">
          <el-checkbox style="margin-right: 0.1vw" @change="handleSelectAll" v-model="selectAll">
            <span style="color: #000; font-size: 18rem">全选</span>
          </el-checkbox>
        </div>
        <div class="seNumber">已选<span>{{ (list2.filter(item => item.checked)).length }}</span>/共{{ list2.length }}</div>
        <div class="btn" style="margin-left: 2.7vw" @click="handleReverseSelectAll">反选</div>
        <div class="btn" style="margin-left: 1vw" @click="handleList2(list2, false)">取消选择</div>
        <div class="preview" @click="preview()">账单总览</div>
      </div>
    </div>
    <DialogManage
        ref="DialogManageRef"
    />
    <DialogEntering
        ref="DialogEnteringRef"
        :type="typeDialogEnter"
        :title="titleDialogEnter"
        @getInit="getInit"
    />
    <DialogClose
        ref="DialogCloseRef"
        @getInit="getInit"
    />
    <!--    预览账单窗口-->
    <DownLoadTable1 v-if="isLoad" @hidden="hidden" :tableDate="tableDate"/>
  </div>
</template>

<script>

import DialogManage from './dialogManage'
import DialogEntering from './dialogEntering'
import DialogClose from './dialogClose'
import DownLoadTable1 from './DownLoadTable1.vue'
import Loading from '../../../components/common/Loading.vue'
import {
  GET_V3_Room_List_Page,
  PUT_V3_Cost_Enterprise_Charges_Details,
  GET_V3_Cost_Meter_Status_Totals,
  GET_V3_Cost_Room_Valid_Password
} from '@/api/billing.js'
import store from "@/store/index"

export default {
  name: "Card",
  props: [
    'tabidx',
    'currentTime',
    'searchValue',
    'list2Data',
    'radio1',
    'radio2',
    'isRequest',
    'STATUS_COUNT'
  ],
  components: {
    DialogManage,
    DialogEntering,
    DialogClose,
    DownLoadTable1,
    Loading
  },
  data() {
    return {
      list1: [],
      list2: [],
      checkedList: [],
      selectAll: false,
      isLoad: false, // 下载窗口开头
      tableDate: [], //下载表格数据
      typeDialogEnter: '',
      titleDialogEnter: '',
      isRefresh: true
    }
  },

  created() {
    this.getInit()
  },

  methods: {
    // 获取电表状态数量
    async getSTATUS_COUNT() {
      const {data} = await GET_V3_Cost_Meter_Status_Totals()
      // console.log('获取电表状态数量', data)
      this.$emit("update:STATUS_COUNT", data.data)
    },

    // 初始化数据
    getInit(time, selectItemValue) {
      this.$emit('update:isRequest', true)
      this.isRefresh = false
      // console.log(this.tabidx)
      if (this.tabidx === 0) {
        GET_V3_Room_List_Page({
          roomName: this.searchValue,
          // 排序方式 房间号 BY_ROOM_NAME, 用户 BY_TENANT_NAME
          sortBy: this.radio1,
          roomStatus: selectItemValue
        }).then((res) => {
          // console.log('计费概况的数据', res)
          if (res.data.code == 200) {
            this.list1 = res.data.data.content || []
            this.getSTATUS_COUNT()
          } else {
            this.list1 = []
            this.$message.error('获取数据信息失败')
          }
          // this.$emit('update:isRequest', false)
        })
        setTimeout(() => {
          this.$emit('update:isRequest', false)
        }, 500)
      } else if (this.tabidx === 1) {
        PUT_V3_Cost_Enterprise_Charges_Details({
          year: time ? time[0] : this.currentTime[0],
          month: time ? time[1] : this.currentTime[1],
          projectId: store.getters.projectId,
          sortBy: this.radio2,
          enterpriseName: this.searchValue
        }).then((res) => {
          this.isRefresh = true
          if (res.data.code == 200) {
            // console.log('账单管理的数据', res)
            this.$emit('update:list2Data', res.data.data)
            this.list2 = res.data.data.list || []
            this.handleList2(this.list2)
          }
          setTimeout(() => {
            this.$emit('update:isRequest', false)
          }, 500)
        })
        this.$emit('update:isRequest', false)
      } else {
        // this.$emit('update:isRequest', false)
        return
      }
    },

    handleList2(list, flag = false) {
      this.list2 = list.map((item) => {
        return {
          ...item,
          checked: flag
        }
      })
    },

    // 全选
    handleSelectAll() {
      this.handleList2(this.list2, this.selectAll)
    },

    // 反选
    handleReverseSelectAll() {
      this.list2 = this.list2.map(item => {
        return {
          ...item,
          checked: !item.checked
        }
      })
    },

    handleDialog(type, type2, title, item) {
      switch (type) {
        case 'manage':
          // console.log('房间管理信息===', item)
          this.$refs.DialogManageRef.roomData = item;
          this.$refs.DialogManageRef.dialogVisible = true;
          break;
        case 'entering':
          this.typeDialogEnter = type2
          this.titleDialogEnter = title
          this.$refs.DialogEnteringRef.dialogVisible = true;
          break;
        case 'close':
          this.$refs.DialogCloseRef.dialogVisible = true;
          // console.log(item)
          this.$refs.DialogCloseRef.tenement = item
          break;
        default:
          return;
      }
    },

    preview(val) {
      if (!!val) {
        this.tableDate = [val]
        // console.log('单个预览 === ', this.tableDate, this.tableDate[0].roomNames.split(' '))
        this.isLoad = true
      } else {
        let arr = this.list2.filter(item => item.checked)
        // console.log(arr)
        if (arr.length > 0) {
          this.tableDate = arr
          // console.log('整体预览 === ', this.tableDate)
          this.isLoad = true
        } else {
          this.$message({
            message: '请勾选缴费单位',
            type: 'warning'
          });
        }
      }
    },
    // 关闭窗口
    hidden(off) {
      this.isLoad = off
    },
  },

  watch: {
    list2: {
      deep: true,
      handler(val) {
        this.selectAll = this.list2.every(item => item.checked)
      }
    },
    tabidx() {
      this.getInit()
    },
    radio1() {
      this.getInit()
    },
    radio2() {
      this.getInit()
    }
  }
}
</script>

<style scoped lang="less">
::v-deep.el-tag--dark {
  border-color: transparent;
}

::v-deep.el-divider {
  margin: 19rem 0 24rem 0;
}

.nothing {
  width: 100%;
  height: 100%;
  position: relative;

  & > img {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}

.title {
  font-size: 24rem;
  margin-bottom: 16rem;
}

.card {
  display: flex;
  flex-wrap: wrap;

  .card-item {
    width: calc(25% - 15rem);
    height: 220rem;
    background: url('../../../assets/img/DB.png') no-repeat center;
    background-color: #F5F7F9 !important;
    border: 1rem solid #CCCCCC;
    border-radius: 4rem;
    margin: 0 15rem 16rem 0;
    padding: 17rem 0 0 16rem;
    color: #333333;
    position: relative;
    font-size: 18rem;
    overflow: hidden;

    .img_bg {
      position: absolute;
      top: 40rem;
      right: 70rem;
    }

    .card-item-box, .card-item-box1 {
      margin-bottom: 16rem;
      width: 90%;
      height: 18rem;
      line-height: 18rem;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      .card-item-box-span {
        color: #409eff;
        font-weight: 600;
      }
    }

    .card-item-box1 {
      width: 80%;
    }

    .card-item-price {
      position: absolute;
      top: 15rem;
      right: 15rem;
      padding: 0rem 8rem;
      min-height: 24rem;
      line-height: 24rem;
    }

    .card-item-manage {
      position: absolute;
      bottom: 15rem;
      right: 15rem;
      //background-color: #FF5555;
    }

    .card-item-checked {
      position: absolute;
      top: 8rem;
      right: 15rem;
    }
  }

  .card-item1 {
    background: url('../../../assets/img/yituizu.png') no-repeat 190rem 35rem;
  }

  .allselect {
    width: calc(100% - 0.5vw);
    height: 5vh;
    background: #FFFFFF;
    box-shadow: 0px 0px 8px 0px rgba(19, 28, 36, 0.2);
    position: absolute;
    bottom: 0;
    left: 0.5vw;
    display: flex;
    flex-direction: row;
    align-items: center;

    .btn {
      font-size: 18rem;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #333333;
      margin-left: 2.7vw;
      cursor: pointer;
    }

    .seNumber {
      font-size: 16rem;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #666666;
      margin-left: 2.7vw;

      & > span {
        font-weight: bold;
      }
    }

    .preview {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 14vh;
      line-height: 4vh;
      text-align: center;
      height: 4vh;
      background: #0D94FF;
      border-radius: 2px;
      font-size: 18rem;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #FFFFFF;
      cursor: pointer;
    }
  }
}
</style>
